import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtLU: CultureInfo = {
  name: 'pt-LU',
  displayName: 'português (Luxemburgo)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-LU',
  parent: CultureInfoPt
};
